import { Component, Prop, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import noUiSlider from 'nouislider';
import 'nouislider/dist/nouislider.css';

@Component
export class PriceFilters extends ThemeComponent {
    @Prop filter!: ShopifyFilter;

    @Ref() inputMin!: HTMLInputElement;
    @Ref() inputMax!: HTMLInputElement;
    @Ref() priceRangeCheckboxesContainer!: HTMLElement;
    @Ref() priceRangeCheckbox!: HTMLInputElement[];
    @Ref() priceRangeSliderContainer!: HTMLElement;
    @Ref() priceRangeSlider!: HTMLElement;
    @Ref() sliderValueMin!: HTMLSpanElement;
    @Ref() sliderValueMax!: HTMLSpanElement;

    init() {
        // Add event listener for range checkboxes
        for (const checkbox of this.priceRangeCheckbox) {
            this.$listen(checkbox, 'change', () => {
                if (window.innerWidth < 768) { return; }
                // eslint-disable-next-line max-len
                const submit:HTMLButtonElement|null|undefined = checkbox.closest('.collection-filters__group')?.querySelector('[data-ref="apply"]');
                this.handleRangeCheckbox(checkbox);
                submit?.click();
            });
        }

        // Init slider
        this.initSlider();
    }

    handleRangeCheckbox(checkbox: HTMLInputElement) {

        // Uncheck all other checkboxes
        for (const otherCheckbox of this.priceRangeCheckbox) {
            if (otherCheckbox !== checkbox) {
                otherCheckbox.checked = false;
            }
        }

        // Only run if the checkbox is checked
        if (checkbox.checked) {

            // Disable slider
            this.disableSlider();

            // Re-enable checkboxes
            this.reEableRangeCheckboxes();

            // Get checkbox value - and determine lower/upper values
            const value = checkbox.value;
            const valueSplit = value.split('-');
            const lower = valueSplit[0];
            const upper = valueSplit[1];

            // Update hidden inputs
            this.updatePriceInputs(lower, upper);

        // All checkboxes have been unchecked
        } else {

            // Re-Enable Slider
            this.reEnablSlider();

            // Set Input Values Back To Empty
            this.inputMin.value = '';
            this.inputMax.value = '';
        }
    }

    initSlider() {

        // Set config values
        const maxValue = this.filter.range_max / 100;
        let startingValueMin = maxValue * 0.2;
        let startingValueMax = maxValue * 0.8;

        // See if we can get values from data attribute
        if (this.sliderValueMin.hasAttribute('data-value') && this.sliderValueMax.hasAttribute('data-value')) {
            const minValue = this.sliderValueMin.getAttribute('data-value');
            if (minValue) {
                startingValueMin = parseInt(minValue, 10);
            }
            const maxValue = this.sliderValueMax.getAttribute('data-value');
            if (maxValue) {
                startingValueMax = parseInt(maxValue, 10);
            }
        }

        // Init slider
        const slider = noUiSlider.create(this.priceRangeSlider, {
            start: [startingValueMin, startingValueMax],
            connect: true,
            step: 1,
            range: {
                min: 0,
                max: maxValue
            }
        });

        // Listen for changes
        slider.on('slide.one', () => {

            // Disable checkboxes
            this.disableRangeCheckboxes();

            // Get data- and determine lower/upper values
            const data = slider.get();
            const lowerValue = parseInt(Object.values(data)[0], 10);
            const lower = lowerValue.toString();
            const upperValue = parseInt(Object.values(data)[1], 10);
            const upper = upperValue.toString();

            // Update visible inputs
            this.sliderValueMin.innerHTML = lower;
            this.sliderValueMax.innerHTML = upper;

            // Update hidden inputs
            this.updatePriceInputs(lower, upper);

            // Submit
            if (window.innerWidth < 768) { return; }
            // eslint-disable-next-line max-len
            const submit:HTMLButtonElement|null|undefined = this.sliderValueMax.closest('.collection-filters__group')?.querySelector('[data-ref="apply"]');
            submit?.click();
        });
    }

    updatePriceInputs(lower: string, upper: string) {
        this.inputMin.value = lower;
        this.inputMax.value = upper;
    }

    disableSlider() {
        this.priceRangeSliderContainer.classList.add('price-filters-slider--disabled');
    }

    reEnablSlider() {
        this.priceRangeSliderContainer.classList.remove('price-filters-slider--disabled');
    }

    disableRangeCheckboxes() {
        this.priceRangeCheckboxesContainer.classList.add('collection-filters__group-options__list--disabled');

        // Uncheck all boxes
        for (const checkbox of this.priceRangeCheckbox) {
            checkbox.checked = false;
        }
    }

    reEableRangeCheckboxes() {
        this.priceRangeCheckboxesContainer.classList.remove('collection-filters__group-options__list--disabled');
    }
}
